import parsingLinkInComment from '@/helpers/parsingLinkInComment';
import { Dispatch, SetStateAction } from 'react';
import styled from 'styled-components';
import { ViewCommentMode } from '../../../constant/comment';
import { ICommentSideModal } from '../../../interfaces/components/comment.interface';
import { ICommentInteract } from '../../../interfaces/hook.interface';
import CommentForm from '../../comment/CommentForm';

interface ICommentCardContent extends ICommentInteract {
  content: string;
  id: string;
  parentId?: string;
  mode: ViewCommentMode;
  setModeTo: Dispatch<SetStateAction<ViewCommentMode>>;
}

const CommentCardContent = ({
  content,
  id,
  parentId,
  toast,
  openConfirm,
  handleUpdateGlobal,
  handleAddGlobal,
  mode,
  setModeTo,
}: ICommentCardContent & ICommentSideModal) => {
  const parsedContent = parsingLinkInComment(content);

  return (
    <div className="flex-1 overflow-hidden rounded-md">
      {mode === ViewCommentMode.View ? (
        <StyledP
          dangerouslySetInnerHTML={{
            __html: parsedContent,
          }}
          className="text-md whitespace-pre-line bg-[#F2F2F2] px-5 py-2 text-grey_helper break-word-legacy"
        ></StyledP>
      ) : (
        <div
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          <CommentForm
            placeholder={
              !parentId ? 'Nhập bình luận tại đây' : 'Nhập phản hồi tại đây'
            }
            oldContent={content}
            commentId={id}
            handleCancel={() => {
              setModeTo(ViewCommentMode.View);
            }}
            toast={toast}
            openConfirm={openConfirm}
            handleAddGlobal={handleAddGlobal}
            handleUpdateGlobal={handleUpdateGlobal}
          />
        </div>
      )}
    </div>
  );
};

export default CommentCardContent;

const StyledP = styled('p')`
  a {
    color: #3cacdd;
  }

  a:hover {
    text-decoration: underline;
  }
`;
